import { ActionType } from 'typesafe-actions';
import { call, put, debounce, takeLeading } from 'redux-saga/effects';
import { rejectPromiseAction, resolvePromiseAction } from 'redux-saga-promise-actions';
import { request } from 'store/sagas/api';

import * as actions from 'store/actions/installments';
import Endpoints from 'endpoints';
import Pinpad from 'endpoints/Pinpad';
import { Installments } from 'store/types/installments';
import GipsyApi from 'apis/GipsyGDS';
import { getInstallments } from '../actions/installments';

function* getInstallment(action: ActionType<typeof actions.getInstallments.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  const { price } = action.payload;
  try {
    const response = yield call(GipsyApi.request, {
      method: 'get',
      url: Endpoints.installments(),
      params: {
        value: price,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(actions.getInstallments.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
  } catch (err) {
    yield put(actions.getInstallments.failure());
    yield call(rejectPromiseAction, action, err);
  }
}

export const watchInstallments = [takeLeading(actions.getInstallments.request, getInstallment)];
